/* 
 *
 * analysis.js 
 *
 */

import {
    createSlice
} from "@reduxjs/toolkit";

import analysisAPI from ".././../api/analysisAPI";
import thunk from "../../helpers/thunk";
/* thunks */

const fetchProjectAnalyses = thunk(
    "analysis/fetchProjectAnalyses",
    analysisAPI.fetchByProject,
    o => ({
        projectID: o.d.projectID,
        data: o.r.data
    })
);

const fetchAnalysis = thunk(
    "analysis/fetchAnalysis",
    analysisAPI.fetchByID,
    o => o.r
);

const deleteAnalysis = thunk(
    "analysis/deleteAnalysis",
    analysisAPI.delete,
    o => ({
        analysisIDs: o.d.IDs,
        projectID: o.d.projectID
    })
);

const fetchAnalyses = thunk(
    "analysis/fetchAnalyses",
    analysisAPI.fetchAll,
    o => o.r
);

const analyze = thunk(
    "analysis/analyze",
    analysisAPI.analyze,
    o => ({
        data: o.r.data,
        taskID: o.d.taskID,
        projectID: o.d.projectID
    })
);

/* slice */
const slice = createSlice({
    name: "analysis",
    initialState: {
        analyses: {}
    },
    reducers: {

    },
    extraReducers: {
        [fetchProjectAnalyses.fulfilled]: (state, action) => {
            const analyses = action.payload.data;

            analyses.forEach(analysis => {
                state.analyses[analysis.ID] = {
                    taskID: analysis.taskID,
                    taskCount: analysis.taskCount,
                    name: analysis.name,
                    created: analysis.created,
                    createdBy: analysis.createdBy
                }
            });
        },
        [analyze.fulfilled]: (state, action) => {
            const analysis = action.payload.data;

            state.analyses[analysis.ID] = {
                taskID: analysis.taskID,
                taskCount: analysis.taskCount,
                name: analysis.name,
                created: analysis.created,
                createdBy: analysis.createdBy
            }
        },
        [fetchAnalysis.fulfilled]: (state, action) => {
            const analysis = action.payload.data;

            state.analyses[analysis.ID] = {
                tasks: analysis.tasks,
                taskCount: analysis.taskCount,
                taskID: analysis.taskID,
                name: analysis.name,
                created: analysis.created,
                createdBy: analysis.createdBy,
                rows: analysis.rows
            }
        },
        [fetchAnalyses.fulfilled]: (state, action) => {
            const analyses = action.payload.data;

            analyses.forEach(analysis => {
                state.analyses[analysis.ID] = {
                    tasks: analysis.tasks,
                    taskCount: analysis.taskCount,
                    taskID: analysis.taskID,
                    name: analysis.name,
                    created: analysis.created,
                    createdBy: analysis.createdBy
                }
            });
        },
        [deleteAnalysis.fulfilled]: (state, action) => {
            const analysisIDs = action.payload.analysisIDs;

            analysisIDs.forEach(analysisID => {
                delete state.analyses[analysisID];
            });
        }
    }
});

export {
    fetchProjectAnalyses,
    analyze,
    fetchAnalysis,
    fetchAnalyses,
    deleteAnalysis
};
export const {} = slice.actions;
export default slice.reducer;